module.exports = __webpack_public_path__ + "static/img/myLeague-no.34882c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/myLeague-no.svg
// module id = 4eks
// module chunks = 0